var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZan = function SvgZan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#505259",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.25 5.13c0 .413.336.75.75.75h1.992c1.507 0 2.597 1.46 2.16 2.921l-1.144 3.833a2.26 2.26 0 0 1-2.349 1.608l-7.759-.65a1.26 1.26 0 0 1-1.15-1.258V7.337c0-.62.446-1.144 1.049-1.245l.237-.04a2.76 2.76 0 0 0 2.09-1.664l1.242-2.993c.253-.61.994-.833 1.537-.47.338.228.697.519.963.834.275.325.382.593.382.788z"
  })));
};
export default SvgZan;